module.exports = __webpack_public_path__ + "static/media/kh.ec5dcd4d.svg";